/*@ngInject*/
const SubmissionUtil = function ($rootScope, $uibModal, $q, submissionMediator, submissionStateMediator,
                                                wizardMediator, $timeout, $stateParams, $state, submissionConstant,
                                                loadingBarHandler, preferenceModel) {
    var showWaitingDialog = true,
        pushedWizardContext;

    function handleAfterCloseSubmission() {
        submissionStateMediator.deleteNewSubmissionState();
        $rootScope.$broadcast(submissionConstant.event.RELOAD_SUBMISSION, $stateParams.submissionId);
    }

    function openNewSubmissionModal(submission, formId) {
        var hierarchicalContextList = [];

        pushedWizardContext = wizardMediator.getContext();

        wizardMediator.setContextType(submissionConstant.CONTEXT_SUBMISSION);
        wizardMediator.setContextId(submission.id);
        wizardMediator.setContextLabel(submission.submissionTabDisplayName || submission.insured.name || '');
        wizardMediator.setContextUri(submission.objectUri);
        hierarchicalContextList.push({
            contextId: submission.id,
            contextType: submissionConstant.CONTEXT_SUBMISSION,
            contextUri: submission.objectUri
        });
        wizardMediator.setHierarchicalContextList(hierarchicalContextList);

        submissionStateMediator.saveNewSubmissionState({
            submissionId: submission.id,
            formId: formId,
            state: $state.current.name,
            stateParams: $stateParams
        });

        var modalInstance = $uibModal.open({
            templateUrl: '/create/createSubmissionModal.tpl.html',
            controller: 'createSubmissionModalController',
            windowClass: 'createSubmissionModal',
            resolve: {
                submissionId: function () {
                    return submission.id;
                },
                formId: function () {
                    return formId;
                }
            },
            keyboard: false,
            backdrop: 'static'
        });

        function handleSuccess() {
            submissionStateMediator.deleteNewSubmissionState();
        }

        modalInstance.result.then(handleSuccess, handleAfterCloseSubmission).finally(function () {
            wizardMediator.setContext(pushedWizardContext);
        });
    }

    function showLoader() {
        $timeout(function () {
            if (showWaitingDialog) {
                loadingBarHandler.showLoadingBar('loadingBar.defaultMessage');
            }
        }, 500);
    }

    function hideLoader() {
        showWaitingDialog = false;
        loadingBarHandler.hideLoadingBar();
    }

    this.createNewSubmission = function () {
        var deferred = $q.defer();

        showLoader();

        function handleSuccess(newSubmissionPayload) {
            openNewSubmissionModal(newSubmissionPayload.submissionSummary, newSubmissionPayload.submissionFormId);

            hideLoader();
            deferred.resolve();
        }

        function handleError() {
            hideLoader();
            deferred.reject();
        }

        submissionMediator.createSubmission().then(handleSuccess, handleError);

        return deferred.promise;
    };

    this.restoreCreateSubmissionModal = function () {
        var newSubmission = submissionStateMediator.getNewSubmissionState(),
            isCurrentState, isStateParamsEqual;

        if (!newSubmission) {
            return;
        }

        isCurrentState = $state.current.name === newSubmission.state;
        isStateParamsEqual = _.isEqual($stateParams, newSubmission.stateParams);

        if (isCurrentState && isStateParamsEqual) {
            submissionMediator.openSubmission(newSubmission.submissionId).then(function (submission) {
                openNewSubmissionModal(submission, newSubmission.formId);
            });
        }
    };

    this.setLatestSubmissionAsCurrent = function () {
        handleAfterCloseSubmission();
    };

    this.getSubmissionTransactionExternalLink= function(uri){
        let baseUrl = preferenceModel.get('system.baseURL');
        baseUrl = baseUrl.replace(/\/\s*$/, '')
        return baseUrl+`/submissionTransaction/external/?objectURI=${uri}`;
    }

};

angular.module('gw-um-submission')
    .service('submissionUtil', SubmissionUtil);
